
<mat-card class="fuse-card-medium text-center">
  <mat-card-title>{{this.title}}</mat-card-title>
  <div style="display: flex; flex-direction:column; justify-content: center; align-items: center;">
      <img mat-card-image src="/assets/icons8-installazione-degli-aggiornamenti.svg" alt="" class="matIconCardMedium" /></div>
  <mat-card-content>
      <p>{{this.content}}</p>
  </mat-card-content>
  <mat-card-actions>
      <button mat-button color="primary" (click)="navigate()">
        {{this.buttontext}}
          <mat-icon>arrow_right_alt</mat-icon>
      </button>
  </mat-card-actions>
</mat-card>


